module.exports = __webpack_public_path__ + "img/9791163161349.39d80de6.jpg";